import { http } from '@/plugins/http';
import { getData } from '@/utils/get';

class Event {
  get = () => http.post('events', []).then(getData);
}

export default new Event();
